import { takeLatest, put, type PayloadAction } from '@spcc/core'
import { authActions } from '@spcc/domains/auth'
import { initActions } from '@spcc/domains/portal-init'

/**
 * Handle initialization failure
 * In kiosk mode, if /me (portal init) fails, we should force a logout
 * to ensure the app returns to a clean state.
 */
function* handleInitFailure(action: PayloadAction<string>) {
  if (import.meta.env.DEV) {
    console.warn(`[AuthMonitoring] Portal initialization failed: ${action.payload}. Triggering auto-logout.`)
  }
  yield put(authActions.logout())
}

/**
 * Auth Monitoring Saga
 * Watches for authentication-related events and takes corrective actions
 */
export function* authMonitoringSaga() {
  yield takeLatest(initActions.initializeFailure.type, handleInitFailure)
}
